var $ = jQuery.noConflict();
var $headerLogo,
	$header,
	scrollController,
	scrollWord,
	scrollWordText,
	scrollWordScrollX,
	scrollWordMaxScrollX,
	lastScrollPos = 0,
	scrollDirection;

$(function () {

	window.onscroll = function () {
		scrollListener();
	};
	window.addEventListener('resize', resizeListener);

	$headerLogo = $('.header-logo');
	$header = $('.main-header');
	scrollController = new ScrollMagic.Controller();
	//homepage scrolling word
	scrollWord = $('.scrolling-text svg');
	if (scrollWord.length) {
		initScrollingText();
	}
	madeByMcube();
	initParallaxImages();
	initForms();
	initHeader();
	initNavContact();
	initMomentsSlider();
	initEllipsis();
	initGallery();
	initLinks();
	initMap();
	initSingleProduct();
	//appear on scroll
	AOS.init({
		once: true
	});
});


function resizeListener() {
	//homepage scrolling word
	if (scrollWord.length) {
		resizeScrollingText();
	}
	//resizeNavContact();
}

function scrollListener() {
	tinyHeader();
}

function consoleLog($message, $bg, $color) {
	console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;');
}

function madeByMcube() {
	consoleLog(' ');
	consoleLog('Fabriqué à Lyon par Mcube', '#FA3348', '#ffffff');
	consoleLog('www.mcube.fr');
	consoleLog(' ');
}